module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"da":{"input":{"optional":"valgfrit"}},"de":{"version":1,"input":{"optional":"optional"}},"en":{"input":{"optional":"optional"}},"fr":{"input":{"optional":"optionnel"}},"nl":{"input":{"optional":"optioneel"}},"pl":{"input":{"optional":"opcjonalnie"}}}')
  delete Component.options._Ctor
}
